import { buildControllerRules } from "@gettactic/helpers/src/hook-form/buildControllerRules";
import React from "react";
import { Controller, FieldValues } from "react-hook-form";
import { UnifiedSelectInput } from "./UnifiedSelectInput";
import { HookFormUnifiedSelectInputProps } from "./UnifiedSelectInput.types";

export const HookFormUnifiedSelectInput = <T extends FieldValues, D = unknown>({
  form,
  name,
  rules,
  onChange,
  multiselect = false,
  ...props
}: HookFormUnifiedSelectInputProps<T, D>): React.ReactElement => {
  return (
    <Controller
      control={form.control}
      name={name}
      rules={buildControllerRules({
        form,
        name,
        rules,
        isRequired: props.isRequired
      })}
      render={({ field, fieldState }) => {
        if (multiselect) {
          // For multiselect, field.value should be an array of strings
          const values = Array.isArray(field.value) ? field.value : [];
          return (
            <UnifiedSelectInput<D>
              ref={field.ref}
              {...props}
              multiselect={true}
              values={values}
              onChangeValues={(newValues) => {
                field.onChange(newValues);
                onChange?.(newValues);
              }}
              error={fieldState.error?.message}
            />
          );
        } else {
          // For single select, field.value should be a string
          const value = typeof field.value === "string" ? field.value : "";
          return (
            <UnifiedSelectInput<D>
              ref={field.ref}
              {...props}
              multiselect={false}
              value={value}
              onChangeValue={(newValue) => {
                field.onChange(newValue);
                onChange?.(newValue);
              }}
              error={fieldState.error?.message}
            />
          );
        }
      }}
    />
  );
};
